import Button from '@rio-cloud/rio-uikit/Button';
import { FormattedMessage } from 'react-intl';
import ButtonToolbar from '@rio-cloud/rio-uikit/ButtonToolbar';
import classNames from 'classnames';

export const ExportModalFooter = ({
    isLoading,
    downloadDisabled,
    handleDownload,
    handleCancel,
    resetFilters,
}: {
    isLoading: boolean;
    downloadDisabled: boolean;
    handleCancel: () => void;
    handleDownload: () => void;
    resetFilters: () => void;
}) => (
    <>
        <Button
            iconName="rioglyph-revert"
            bsStyle={Button.PRIMARY}
            variant={Button.VARIANT_LINK}
            onClick={resetFilters}
        >
            <FormattedMessage id="outboundOrderBook.common.table.toolbar.filter.reset" />
        </Button>
        <ButtonToolbar>
            <Button onClick={handleCancel}>
                <FormattedMessage id="outboundPortal.cancel" />
            </Button>
            <Button
                className={classNames(isLoading ? 'btn-loading' : '')}
                disabled={downloadDisabled || isLoading}
                iconName="rioglyph-download"
                bsStyle={Button.PRIMARY}
                onClick={handleDownload}
            >
                <FormattedMessage id="outboundOrderBook.export.download" />
            </Button>
        </ButtonToolbar>
    </>
);
